<template>
    <v-skeleton-loader
        v-if="isLoading"
        type="image"
        max-height="150"
    ></v-skeleton-loader>

    <v-card
        v-else
        class="fill-height"
        :to="{ name: 'kelon' }"
    >
        <div class="d-flex justify-space-between align-center">
            <div>
                <v-card-title>Kelon</v-card-title>
                <v-card-subtitle>Video kelas atau materi</v-card-subtitle>
            </div>

            <div>
                <v-icon
                    class="mr-4"
                    x-large
                >
                    mdi-video
                </v-icon>
            </div>
        </div>

        <v-card-text class="display-1 py-md-0 mb-2">
            {{ count }} Video
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    data: () => ({
        isLoading: true,
        count: null,
    }),

    async created() {
        const response = await this.$apiv2.get(`user/period/kelon/video/count`)
        this.count = response.data.count
        this.isLoading = false
    },
}
</script>
